// app/javascript/packs/partners_form.js
import { initSelectStateMunicipality } from '../utils/select_state_municipality';

let destroySelectStateMunicipality = null;

function setupPartnersForm() {
    // const form = document.getElementById("partners-form");
    // if (!form) return;
    const stateSelect = document.querySelector('#partner_state_id');
    if (!stateSelect) return;
    destroySelectStateMunicipality = initSelectStateMunicipality(
        '#partner_state_id',
        '#partner_municipality_id',
        '/partners/get_municipalities'
    );
}

function destroyPartnersForm() {
    if (destroySelectStateMunicipality) {
        destroySelectStateMunicipality();
        destroySelectStateMunicipality = null;
    }
}

// Se ejecuta cada vez que Turbolinks carga una vista nueva
document.addEventListener("turbolinks:load", setupPartnersForm);

// Limpieza antes de que Turbolinks cachee el snapshot (navegación interna)
document.addEventListener("turbolinks:before-cache", destroyPartnersForm);

// Limpieza si el usuario cierra la pestaña, refresca, o navega fuera de Turbolinks
window.addEventListener("beforeunload", destroyPartnersForm);